
import {Link, Outlet, useLocation} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../utilis/contexts/AuthContext";
import {Button, Divider, Drawer, Typography} from "antd";
import AbfaLogo from "../../images/logo.png"
import {MenuOutlined, UserOutlined} from "@ant-design/icons";
const RegisterLetterLayout=()=>{
    const location=useLocation();
    const authContext=useContext(AuthContext);
    const [openDrawer,setOpenDrawer]=useState(false);
    useEffect(() => {
        setOpenDrawer(false)
    }, [location.pathname]);
    return <div className="w-full bg-gray-100 flex justify-start  flex-col lg:flex-row items-start lg:p-5 min-h-screen">
        <div className="w-full py-3  bg-white shadow-sm mb-2 lg:hidden">
            <div className="w-11/12 mx-auto flex items-center justify-between">
                <MenuOutlined onClick={()=>setOpenDrawer(true)}/>
                <img alt="" src={AbfaLogo} className="w-[50px]"/>
            </div>
            <Drawer

                onClose={() => setOpenDrawer(false)}
                open={openDrawer}
            >

                <div className="flex w-full gap-2 bg-gray-50  p-4 rounded-xl justify-start items-center">
                    <div className="text-gray-800 bg-gray-200 flex   items-center p-5 rounded-full">
                        <UserOutlined className='text-white'/>
                    </div>
                    <div className="flex flex-col">
                        <span className="text-sm font-semibold">{authContext.user.name}</span>
                        <span className="text-sm ">{authContext.user.cellphone}</span>

                    </div>
                </div>
                <Divider/>
                {!authContext?.user?.is_admin && <>
                    <div className="flex gap-4 flex-col w-full ">
                        <Link
                            className={` text-black  px-4 py-2 rounded-lg ${location.pathname.includes('register-letter') ? 'bg-primary bg-opacity-10 text-primary' : ''}`}
                            to="register-letter">ثبت درخواست</Link>
                        <Link
                            className={`text-black px-4 py-2 rounded-lg ${location.pathname.includes('tracking-letter') ? 'bg-primary bg-opacity-10  text-primary' : ''}`}
                            to="tracking-letter">پیگیری درخواست</Link>
                    </div>
                    <Divider/>

                </>}
                <Button onClick={authContext.logout} type="primary" size="large" className="mt-5 w-full" danger>خروج از حساب کاربری</Button>
            </Drawer>
        </div>
        <div
            className="hidden side-bar bg-white lg:flex p-5 flex-col justify-start items-center   b-white   rounded-xl w-[350px]">
            <div className="flex gap-2 flex-col justify-center items-center">
                <img alt="" src={AbfaLogo} className="w-[60px]"/>
                <Typography className="text-center font-bold">شرکت آب و فاضلاب استان مازندران</Typography>
            </div>
            <Divider/>
            <div className="flex w-full gap-2 bg-gray-50  p-4 rounded-xl justify-start items-center">
                <div className="text-gray-800 bg-gray-200 flex   items-center p-5 rounded-full">
                    <UserOutlined className='text-white'/>
                </div>
                <div className="flex flex-col">
                    <span className="text-sm font-semibold">{authContext.user.name}</span>
                    <span className="text-sm ">{authContext.user.cellphone}</span>

                </div>
            </div>
            <Divider/>
            {!authContext?.user?.is_admin && <>
                <div className="flex gap-4 flex-col w-full ">
                    <Link
                        className={` text-black  px-4 py-2 rounded-lg ${location.pathname.includes('register-letter') ? 'bg-primary bg-opacity-10 text-primary' : ''}`}
                        to="register-letter">ثبت درخواست</Link>
                    <Link
                        className={`text-black px-4 py-2 rounded-lg ${location.pathname.includes('tracking-letter') ? 'bg-primary bg-opacity-10  text-primary' : ''}`}
                        to="tracking-letter">پیگیری درخواست</Link>
                </div>
                <Divider/>
            </>}


            <Button onClick={authContext.logout} type="primary" size="large" className="mt-5 w-full" danger>خروج از حساب کاربری</Button>

        </div>
        <div className="w-full flex justify-center lg:w-[calc(100%-350px)]  lg:px-5">
            <div className="mx-auto w-11/12 lg:w-full ">
                <Outlet/>
            </div>

        </div>

    </div>
}
export default RegisterLetterLayout;